export const routes = {
  root: "/",
  manager: "/manager",
  builder: "/builder",
  report: "/report",
  ExampleBizCharts: "/examples/bizcharts",
  ExampleBizChartsHTML: "/examples/bizcharts.html",
  ExampleChartsJS: "/examples/chartjs",
  ExampleChartsJSHTML: "/examples/chartjs.html",
};
